import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {useMediaQuery} from 'react-responsive';
import SectionWrapper from 'ferries/Home/components/SectionWrapper';
import Button from 'helpers/Button';
import LazyImage from 'helpers/LazyImage';
import {TABLET_WIDTH} from 'helpers/stableValues';

const PopularRoutes = ({routes}) => {
  const isTablet = useMediaQuery({query: `(max-width: ${TABLET_WIDTH}px)`});
  const {title, subtitle, description, items, trs} = routes;

  return (
    <SectionWrapper title={title} subtitle={subtitle} description={description}>
      {
        items.map(({code, arr, dep, companyLogo, company, vessel, duration, price, url, book}, index) => {
          const wrapperClasses = classNames(
            'grid no-gutter align-items-center',
            {'bg-snow': index % 2 === 0, 'border-top': isTablet ? index !== 0 : false}
          );

          const rowClasses = 'grid-item p-3 d-flex';
          const mobileRowClasses = 'd-flex align-items-center';

          return (
            <div key={code} className={wrapperClasses}>
              {isTablet ?
                <div className="grid-item p-3">
                  <a href={url} target="_blank" rel="noreferrer" className={mobileRowClasses}>
                    <i className="icon icon-document mr-2" aria-hidden="true"/>
                    {dep} - {arr}
                  </a>
                  <div className={mobileRowClasses}>
                    <LazyImage
                      wrapperClass="mr-2"
                      imgClass="d-flex align-items-center rounded border-gray-light"
                      src={companyLogo}
                      width="16"
                      height="16"
                      title={company}
                      alt={company}
                    />
                    <div><b>{company}</b><br/>{vessel}</div>
                  </div>
                  <div className={mobileRowClasses}>
                    <i className="icon icon-time-clock mr-2" aria-hidden="true"/>
                    {duration}
                  </div>
                  <div className={mobileRowClasses}>
                    <i className="icon icon-event-ticket mr-2" aria-hidden="true"/>
                    <b>{price}</b>
                  </div>
                </div> :
                <>
                  <a href={url} target="_blank" rel="noreferrer" className={`${rowClasses}`}>{dep} - {arr}</a>
                  <div className={`${rowClasses} align-items-center`}>
                    <LazyImage
                      wrapperClass='mr-2'
                      imgClass="rounded-logo"
                      src={companyLogo}
                      width="44"
                      height="44"
                      title={company}
                      alt={company}
                    />
                    <div><b>{company}</b><br/>{vessel}</div>
                  </div>
                  <div className={`${rowClasses} justify-content-center`}>{duration}</div>
                </>
              }
              <div className={`${isTablet ? '' : 'grid-item align-items-center'} p-3 d-flex justify-content-end`}>
                <span className="font-bold mr-4 d-none d-md-block">{price}</span>
                <Button
                  href={book}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded"
                  status="primary"
                  size="sm"
                >
                  {trs.findTickets}
                </Button>
              </div>
            </div>
          );
        })
      }
    </SectionWrapper>
  );
};

PopularRoutes.propTypes = {
  routes: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    trs: PropTypes.shape({
      findTickets: PropTypes.string.isRequired
    })
  })
};

export default PopularRoutes;
